import React, { Component } from 'react';

class brands extends Component{


    render(){

        return(
            <div>Hello

            </div>
        );
    }
}
export default brands;